module.exports = __webpack_public_path__ + "img/EQRx-Logo.20e79b44.svg";